import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "col p-3" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "field-title" }, " Does this patient have an advanced care plan or a surrogate decision maker AND able to provide legal documentation for the hospice medical record? ", -1 /* HOISTED */)
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "advanceCarePlanOption1"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_7 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "advanceCarePlanOption2"
}, " No ", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "field-title my-3" }, "Advance Directives", -1 /* HOISTED */)
const _hoisted_10 = ["id", "value", "onChange", "checked"]
const _hoisted_11 = ["for"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "field-title" }, "Code Status", -1 /* HOISTED */)
const _hoisted_15 = ["id", "value", "onChange", "checked"]
const _hoisted_16 = ["for"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_18 = { class: "form-group mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "surrogate-decision-maker" }, "Surrogate Decision Maker Section", -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "field-title" }, " Is any of the following information documented in the patient's advanced plan of care? ", -1 /* HOISTED */)
const _hoisted_22 = { class: "form-group mt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "medical-treatment" }, "Medical Treatment Preferences", -1 /* HOISTED */)
const _hoisted_24 = { class: "form-group mt-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "mental-health" }, "Mental Health/Behavioral Treatment Preferences", -1 /* HOISTED */)
const _hoisted_26 = { class: "form-group mt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "cultural" }, "Cultural/Social Preferences", -1 /* HOISTED */)
const _hoisted_28 = { class: "form-group mt-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "spiritual" }, "Spiritual/Religious Preferences", -1 /* HOISTED */)
const _hoisted_30 = { class: "mt-2" }
const _hoisted_31 = { class: "col-12 col-lg-10 row p-3" }
const _hoisted_32 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "funeral-address-line-2" }, " Auto-fill using vendor list ", -1 /* HOISTED */)
const _hoisted_34 = { class: "col-12 col-lg-4 pe-lg-2 d-flex align-items-end" }
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_37 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "funeral-name" }, " Name ", -1 /* HOISTED */)
const _hoisted_39 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "address-line-1" }, " Address ", -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_42 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "city" }, " City ", -1 /* HOISTED */)
const _hoisted_44 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "state" }, " State ", -1 /* HOISTED */)
const _hoisted_46 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "zip" }, " ZIP ", -1 /* HOISTED */)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_49 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "preferred-phone" }, " Phone Number ", -1 /* HOISTED */)
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "alternate-phone" }, " After Hours Phone Number ", -1 /* HOISTED */)
const _hoisted_54 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_PlacesAutocomplete = _resolveComponent("PlacesAutocomplete")!
  const _component_StateTypeahead = _resolveComponent("StateTypeahead")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_FormSection, {
        title: "Advance Directives",
        "full-height": false,
        "application-id": _ctx.application
      }, {
        content: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAddDocumentModal()))
              }, " Add Document ")
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "advanceCarePlan",
                  id: "advanceCarePlanOption1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.advancedDirectives.hasLegalDocumentation) = $event)),
                  value: true
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.patientDetails.advanceDirectives.advancedDirectives.hasLegalDocumentation]
                ]),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "advanceCarePlan",
                  id: "advanceCarePlanOption2",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.advancedDirectives.hasLegalDocumentation) = $event)),
                  value: false
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.patientDetails.advanceDirectives.advancedDirectives.hasLegalDocumentation]
                ]),
                _hoisted_8
              ])
            ]),
            (_ctx.patientDetails.advanceDirectives.advancedDirectives.hasLegalDocumentation)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.AdvanceDirectivesEnum), ([key, value]) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${value.value}-${value.name}`,
                      class: "form-check custom-checkbox mt-2"
                    }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: `${value.name}-${value.value}`,
                        value: value.value,
                        onChange: ($event: any) => (_ctx.handleAdvDirectivesSelection(value.value)),
                        checked: 
                                    _ctx.patientDetails.advanceDirectives.advancedDirectives.advancedCarePlanDirectives.includes(
                                        value.value
                                    )
                                
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `${value.name}-${value.value}`
                      }, _toDisplayString(key), 9 /* TEXT, PROPS */, _hoisted_11)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.CodeStatusEnum), ([key, value]) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${value.value}-${value.name}`,
                  class: "form-check custom-checkbox mt-2"
                }, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: `${value.name}-${value.value}`,
                    value: value.value,
                    onChange: ($event: any) => (_ctx.handleCodeStatusSelection(value.value)),
                    checked: 
                                    _ctx.patientDetails.advanceDirectives.advancedDirectives.codeStatus.includes(value.value)
                                
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `${value.name}-${value.value}`
                  }, _toDisplayString(key), 9 /* TEXT, PROPS */, _hoisted_16)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Enter Surrogate Decision Maker",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.advancedDirectives.surrogateDecisionMaker) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.patientDetails.advanceDirectives.advancedDirectives.surrogateDecisionMaker]
              ])
            ]),
            _hoisted_20,
            _createElementVNode("div", null, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Enter Treatment Preferences",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.advancedDirectives.medicalPreferences) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.patientDetails.advanceDirectives.advancedDirectives.medicalPreferences]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Enter Mental Health/Behavioral Treatment Preferences",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.advancedDirectives.mentalPreferences) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.patientDetails.advanceDirectives.advancedDirectives.mentalPreferences]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Enter Cultural/Social Preferences",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.advancedDirectives.culturalPreferences) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.patientDetails.advanceDirectives.advancedDirectives.culturalPreferences]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Enter Spiritual/Religious Preferences",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.advancedDirectives.spiritualPreferences) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.patientDetails.advanceDirectives.advancedDirectives.spiritualPreferences]
                ])
              ])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["application-id"])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(_component_FormSection, {
        title: "Funeral Home",
        "full-height": false,
        "application-id": _ctx.application
      }, {
        content: _withCtx(() => [
          _createElementVNode("section", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getVendorList,
                value: _ctx.selectedVendor,
                onValueChanged: _ctx.updateVendor,
                "init-value": _ctx.selectedVendor,
                placeholder: "Search Vendor by Name..."
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("a", {
                target: "_blank",
                href: `${_ctx._redirectURL}`,
                class: "font-size-md mb-3"
              }, " Add Vendor ", 8 /* PROPS */, _hoisted_35)
            ]),
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                type: "text",
                placeholder: "Enter Name",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.name) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.patientDetails.advanceDirectives.patientFuneralHome.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(_component_PlacesAutocomplete, {
                street: _ctx.patientDetails.advanceDirectives.patientFuneralHome.address,
                "onUpdate:street": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.address) = $event)),
                city: _ctx.patientDetails.advanceDirectives.patientFuneralHome.city,
                "onUpdate:city": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.city) = $event)),
                state: _ctx.patientDetails.advanceDirectives.patientFuneralHome.state,
                "onUpdate:state": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.state) = $event)),
                zip: _ctx.patientDetails.advanceDirectives.patientFuneralHome.zipCode,
                "onUpdate:zip": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.zipCode) = $event))
              }, null, 8 /* PROPS */, ["street", "city", "state", "zip"])
            ]),
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                type: "text",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.city) = $event)),
                placeholder: "Enter City"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.patientDetails.advanceDirectives.patientFuneralHome.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createVNode(_component_StateTypeahead, {
                "selected-state": _ctx.selectedState,
                "onUpdate:selected-state": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedState) = $event)),
                "prefill-state": _ctx.patientDetails.advanceDirectives.patientFuneralHome.state,
                "onUpdate:prefill-state": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.state) = $event))
              }, null, 8 /* PROPS */, ["selected-state", "prefill-state"])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "10",
                type: "text",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.patientDetails.advanceDirectives.patientFuneralHome.zipCode) = $event)),
                placeholder: "Enter Zip"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.patientDetails.advanceDirectives.patientFuneralHome.zipCode],
                [_directive_number_only]
              ])
            ]),
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("input", {
                type: "text",
                class: "form-control phone-number-input",
                value: _ctx.formatPhoneNumber(_ctx.patientDetails.advanceDirectives.patientFuneralHome.phoneNumber),
                onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.valueUpdated($event.target.value, 'primary'))),
                maxlength: "14",
                placeholder: "Enter Phone Number"
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_51)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("input", {
                type: "text",
                class: "form-control phone-number-input",
                value: 
                                _ctx.formatPhoneNumber(
                                    _ctx.patientDetails.advanceDirectives.patientFuneralHome.afterHrsPhoneNumber
                                )
                            ,
                onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.valueUpdated($event.target.value))),
                maxlength: "14",
                placeholder: "Enter After Hours Phone Number"
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_54)
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["application-id"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}